import { type ContentNode, type QueryNode } from '@helo/cms'
import { flow } from '@helo/utils'

import type { QueryStoreOutput } from '../QueryStore'
import { RenderPipeline } from '../RenderPipeline'
import { type QueryOptions, queryOptions } from './Query.options'
import { QueryInputParts, QueryOutputParts } from './Query.parts'

export type { QueryOptions } from './Query.options'
export { queryOptions } from './Query.options'

/** Pipeline input consumed by Query.setup. */
export type QueryInput = QueryOptions

/** Pipeline output slice — the query id, store lookup, and status helpers. */
export interface QueryOutput {
  queryId: string
  queryNode: QueryNode | undefined
  isQueryLoading: boolean
  isQueryError: boolean
  queryError: Error | undefined
  contentNode: ContentNode | null
  isEmpty: boolean | null
}

export type QueryPriorOutput = QueryStoreOutput

const querySetup = () =>
  RenderPipeline.createFeatureSetup<QueryInput, QueryOutput, QueryPriorOutput>(
    flow(
      QueryInputParts.setupInput(),
      QueryOutputParts.setQueryLookup(),
      QueryOutputParts.setContentNode(),
      QueryOutputParts.setIsEmpty(),
    ),
  )

export const Query = {
  options: queryOptions,
  setup: querySetup,
}
